import { Typography } from '@mui/material';
import { DocumentsContext } from 'Context/DocumentsContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useContext } from 'react';

export const DocumentAmount = () => {
  const { documents, filter } = useContext(DocumentsContext);

  const { filteredResults, previousYearsResults, results } = documents;
  const { todayDocs, thisWeekDocs, thisMonthDocs, thisYearDocs } = results;

  return (
    <Typography variant='body3'>
      {Dictionary[DICTIONARY.Documents].mobileDocumentsDisplay(
        filter.advancedFilterActive
          ? filteredResults.length
          : previousYearsResults.length +
              todayDocs.length +
              thisWeekDocs.length +
              thisMonthDocs.length +
              thisYearDocs.length
      )}
    </Typography>
  );
};
